import { Box, Typography } from "@mui/material";
import Status from "./Status";
import WhatsaAppContext from './Context'
import NDR from "./NDR";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { FONT, SIZE, WEIGHT } from '../../../styles/foundation/typography';
import { NAVY, PRIMARY_BLUE, SUBTLE } from '../../../styles/foundation/colors';
import { helpTextSx, helpTextTypeSx } from '../../../styles/patterns';

export default function WhatsAppComm({ tab, dateRange }) {
    return (
        <WhatsaAppContext.Provider value={{ dateRange }}>
            <Box sx={helpTextSx}>
                <InfoOutlinedIcon sx={{ fontSize: 16, color: PRIMARY_BLUE, mt: 0.2 }} />
                <Typography sx={helpTextTypeSx}>
                    <strong>WhatsApp Communications:</strong> {tab === 8
                        ? 'View all WhatsApp messages sent for shipment status updates — placed, in-transit, delivered, failed, etc.'
                        : 'Track NDR automation conversations — reattempt confirmations, address corrections, and RTO authorizations via WhatsApp.'}
                </Typography>
            </Box>
            {tab === 8 && <Status />}
            {tab === 9 && <NDR />}
        </WhatsaAppContext.Provider>
    )
}
